import Hr from 'components/shared/Hr/Hr';
import Icon from 'components/shared/Icon/Icon';
import AvatarGroup from 'components/shared/AvatarGroup/AvatarGroup';

const DelegationsReview = ({ data, navigateToSubstep }) => {
  const delegationData =
    data?.substeps?.find((substep) => substep.code === 'onboarding__delegation__delegation')?.data
      ?.delegations || {};
  const delegatedItems = [
    ...(delegationData?.steps || [])
      .filter((step) => step.assignments?.length > 0)
      .map((s) => ({
        id: s.step_id,
        name: s.step_name,
        assigned_users: s.assignments.map((a) => ({
          id: a.user_id,
          fullName: a.first_name + ' ' + a.last_name
        }))
      })),
    ...(delegationData?.substeps || [])
      .filter((substep) => substep.assignments?.length > 0)
      .map((s) => ({
        id: s.substep_id,
        name: s.substep_name,
        assigned_users: s.assignments.map((a) => ({
          id: a.user_id,
          fullName: a.first_name + ' ' + a.last_name
        }))
      }))
  ];

  if (delegatedItems.length === 0) {
    return (
      <div className="px-5 py-5 text-neutral-600">
        <p>No delegations assigned</p>
      </div>
    );
  }

  return (
    <div>
      {data?.substeps?.map((substep) => {
        return (
          <div key={substep.id}>
            <div className="flex items-center gap-2 px-5 pb-3 pt-5">
              <p className="font-600">{substep.name}</p>
              {substep.status === 'Completed' || substep.status === 'Confirmed' ? (
                <Icon icon="check-linear" color="success" />
              ) : (
                <Icon icon="close-linear" color="danger" />
              )}
              <Icon
                icon="link-linear"
                className="cursor-pointer"
                onClick={() => navigateToSubstep(substep.code)}
              />
            </div>
            {substep.data && (
              <div className="px-5">
                <div className="flex justify-between border-b border-neutral-100">
                  <span className="text-sm font-500 text-neutral-600">Status</span>
                  <span className="text-sm text-neutral-900">TBD</span>
                </div>
              </div>
            )}
            <Hr />
            <div className="flex w-full flex-col gap-5 pb-5">
              {delegatedItems.map((item) => (
                <div key={item.id} className="px-5">
                  <div className="flex justify-between border-b border-neutral-100">
                    <p className="text-sm font-500 text-neutral-600">{item.name}</p>
                    <div className="flex items-center gap-2">
                      <p className="text-sm">Delegated to: </p>
                      <AvatarGroup items={item.assigned_users} size="small" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DelegationsReview;
